import { createSelector } from 'reselect'
import { values, find, get, head, some, reduce } from 'lodash'
import moment from 'moment'

import { getCurrentMenuId } from './appState'
import { getSelectedMenusIds } from './config'

const getMenus = state => values(state.menus.byId)

const getStands = state => values(state.stands.byId)

export const getMenusRequestThreshold = () => 1

export const getMenusTimestamp = (state) => state?.menus?.timestamp ?? moment().subtract(2, 'hours').toString()

export const getSelectedMenus = createSelector(
  getMenus,
  getSelectedMenusIds,
  (menus, selectedIds) => menus.filter(menu => selectedIds.includes(menu.uuid))
)

export const getCurrentMenu = createSelector(
  getMenus,
  getCurrentMenuId,
  (menus, currentMenuId) => find(menus, ['uuid', currentMenuId]) || {}
)

export const makeGetCurrentMenu = () => createSelector(getCurrentMenu, menu => menu)

export const getCurrentStand = createSelector(
  getStands,
  getCurrentMenu,
  (stands, currentMenu) => find(stands, ['uuid', currentMenu.standUuid])
)

export const getIsStandAvailable = createSelector(
  getSelectedMenus,
  (menus) => {
    if (menus.length > 1) {
      return some(menus, 'isAvailable')
    } else if (menus.length === 1) {
      const firstMenuUuid = get(head(menus), 'uuid')
      return get(find(menus, ['uuid', firstMenuUuid]), 'isAvailable', false)
    } else {
      return false
    }
  }
)

export const getSelectedMenusImages = createSelector(
  getSelectedMenus,
  (selectedMenus) =>
    selectedMenus
      .map(menu => get(menu, 'images.detail'))
      .filter(image => !!image)
)

export const getMenuById = (state, menuId) => get(state, `menus.byId.${menuId}`, {})

export const getMenuByItemId = (state, itemId) => {
  const itemsByMenuType = state?.items?.byMenuId
  const itemMenuId = reduce(itemsByMenuType, (found, menuCatalog, menuId) => {
    if (found) return found
    if (menuCatalog.byId[itemId]) return menuId
  }, false)

  return state?.menus?.byId?.[itemMenuId] ?? {}
}

export const getMenusNeedReload = createSelector(
  getMenus, getMenusTimestamp, getMenusRequestThreshold,
  (menus, timestamp, threshold) => {
    const thresholdExceeded = moment().diff(moment(timestamp), 'hours') > threshold
    const noRecordsAvailable = menus.length === 0

    if (thresholdExceeded || noRecordsAvailable) {
      return true
    } else {
      return false
    }
  }
)
